<script>
    import Monitor from '@/services/Monitor';


    export default {
        components:{

        },
        props: ['roleId','role', 'module'],
        data() {
            return {
                showLoader: false,
                showModal: false,
                tryingToSubmit: false,
                submitted: false
            };
        },
        methods: {
            refreshData() {
                this.$emit('onRefresh')
            },
            resetProps(){
                this.submitted = false
            },
            closeModal() {
                this.showModal = false;
            },

            EditModuleAccess(action) {
                this.tryingToSubmit = true;
                this.submitted = true;

                const formData = {
                    roleId: this.roleId,
                    module: this.module,
                    action: action,
                };

                Monitor.editModuleAccess(formData)
                    .then((response) => {
                        const res = response.data.data ? response.data.data : false;
                        const error = response.data.error ? response.data.error : '';
                        if (res) {
                            this.successmsg('Module Access Edited!');
                            this.refreshData();
                            this.closeModal();
                        } else {
                            this.failedmsg('Failed to Edit Module Access!')
                        }
                    })
                    .catch(error => {
                        const resData = error.response.data.error ? error.response.data.error : 'Failed';
                        const errorMsg = Array.isArray(resData) ? resData[0] : resData;
                        this.failedmsg(errorMsg)
                    })
                    .finally(() => {
                        this.tryingToSubmit = false;
                    });
            },
        },
    }
</script>

<template>
    <b-modal id="manage_module_access" v-model="showModal" @hidden="resetProps" title="Manage Module Access" title-class="font-18" size="md">
        <form @submit.prevent="EditModuleAccess" v-if="!showLoader">
            <p class="text-center font-size-16 mb-3">Module Name <br><span class="text-strong">{{module}}</span></p>
            <p class="text-center font-size-16 ">Role Name <br><span class="text-strong">{{role}}</span></p>
        </form>
        <template v-slot:modal-footer style="justify-content: flex-start">
            <b-button variant="danger" @click="EditModuleAccess('remove')" :disabled="tryingToSubmit || showLoader">
                <b-spinner v-show="tryingToSubmit" small></b-spinner>
                Remove Access</b-button>
            <b-button variant="success" @click="EditModuleAccess('allow')" :disabled="tryingToSubmit || showLoader">
                <b-spinner v-show="tryingToSubmit" small></b-spinner>
                Allow Access
            </b-button>
        </template>
    </b-modal>
</template>
